<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：栏目管理
    -->
  <div class="product">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="商品分类">
          <el-select size="small" v-model="searchForm.category_id" clearable placeholder="所有分类">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.name" :value="item.category_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="栏目类型">
          <el-select size="small" v-model="searchForm.fodder_type" clearable placeholder="所有栏目类型">
            <!-- <el-option label="普通栏目" value="0"></el-option> -->
            <el-option label="酒体" value="1"></el-option>
            <el-option label="盒型" value="2"></el-option>
            <el-option label="瓶型" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上级盒型栏目id">
          <el-input size="small" v-model="searchForm.parent_id" placeholder="上级盒型栏目id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--添加栏目-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加栏目</el-button>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" style="width: 100%" v-loading="loading">
          <el-table-column prop="fodder_name" label="栏目" width="350px">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.file_path" alt="" /></div>
                <div class="info">
                  <div class="name">ID: {{ scope.row.fodder_id }}</div>
                  <div class="name">{{ scope.row.fodder_name }}</div>
                  <div class="price">￥{{ scope.row.fodder_price }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="fodder_type" label="栏目类型">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.fodder_type == 0">普通栏目</span> -->
              <span v-if="scope.row.fodder_type == 1">酒体</span>
              <span v-if="scope.row.fodder_type == 2">盒型</span>
              <span v-if="scope.row.fodder_type == 3">瓶型</span>
            </template>
          </el-table-column>
          <el-table-column prop="category.name" label="分类"></el-table-column>
          <el-table-column prop="create_time" label="添加时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>

    <!--添加-->
    <Add v-if="open_add" :open_add="open_add" :addform="categoryModel" @closeDialog="closeDialogFunc($event, 'add')"></Add>
    <!--修改-->
    <Edit v-if="open_edit" :open_edit="open_edit" :editform="categoryModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>

  </div>
</template>

<script>
  import CustomizationApi from '@/api/customization.js';
  import Add from './Add.vue';
  import Edit from './Edit.vue';
  export default {
    components: {
      Add,
      Edit
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        categoryModel: {
          fodderList: [],
          model: {}
        },
        /*搜索参数*/
        searchForm: {
          category_id: '',
          fodder_type: '',
          parent_id: ''
        },
        /*全部分类*/
        categoryList: [],
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {

      /*获取列表*/
      getData() {
        let self = this;
        let Params = self.searchForm;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        CustomizationApi.fodderList(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.categoryModel.fodderList = self.tableData;
            self.categoryList = data.data.category;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
            self.loading = false;
          });
      },
      /*打开添加*/
      addClick() {
        this.open_add = true;
      },

      /*打开编辑*/
      editClick(item) {
        this.categoryModel.model = item;
        this.open_edit = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getData();
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getData();
          }
        }
      },
      /*删除栏目*/
      deleteClick(row) {
        let self = this;
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {
          CustomizationApi.fodderDel({
            fodder_id: row.fodder_id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData();
          });
        });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getData();
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.$db.setRoute(this, {'page': val});
        let self = this;
        self.loading = true;
        self.curPage = val;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.pageSize = val;
        this.getData();
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/customization/fodder/index.vue